module.exports = __webpack_public_path__ + "static/media/index-pdf.8b8fba70.jpg";